import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { listOrgRoles, assignRole, revokeRole } from "@/api/client";

export function useOrgUsers() {
  return useQuery({
    queryKey: ["orgUsers"],
    queryFn: listOrgRoles,
    staleTime: 2 * 60 * 1000,
  });
}

export function useAssignRole() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: assignRole,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["orgUsers"] });
    },
  });
}

export function useRevokeRole() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: revokeRole,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["orgUsers"] });
    },
  });
}
